class UMGAnalytics {

    storeTypesMap = {
        'shopify-feed': 'shopify',
        'shopify-collection-embed': 'shopify-embed',
        'cope-store': 'cope',
        'cope': 'cope',
        'external-link': 'external-link',
    }
    waitForPushGlobalRetryCount = 0
    pageViewEventFired = false
    userEvents = []

    constructor() {
        this.init()
    }

    // init
    init() {
        const _this = this

        if(UMGAnalyticsData.party_service_id){
            // Push Party Service ID to the dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            'partyserviceID': UMGAnalyticsData.party_service_id
            });
        }

        this.addListeners()

        if (document.querySelector('body.search-results')) {
            const searchTerm = document.querySelector('.search-term')
                ? document.querySelector('.search-term').innerText
                : null
            if (searchTerm) {
                const evt = new CustomEvent('umga:search-results', {
                    detail: {
                        searchTerm
                    }
                })
                window.dispatchEvent(evt)
            }
        }

        if (document.querySelector('body.search-no-results')) {
            const searchTerm = document.querySelector('.search-term')
                ? document.querySelector('.search-term').innerText
                : null
            if (searchTerm) {
                const evt = new CustomEvent('umga:no-search-results', {
                    detail: {
                        searchTerm
                    }
                })
                window.dispatchEvent(evt)
            }
        }

        window.addEventListener('load', function() {
            _this.addOnWindowLoadEventListeners()
        })
    }

    pushGlobalReady() {
        if (typeof PUSH_GLOBAL !== 'undefined') {
            if (typeof window.UMGAnalytics !== 'undefined') {
                window.UMGAnalytics.firePageDataLoaded()
            } else {
                this.firePageDataLoaded()
            }
        } else {
            this.waitForPushGlobalRetryCount++;
            // wait a maximum of 1 minute
            if (this.waitForPushGlobalRetryCount > 600) {
                console.log('UMG Analytics: Giving up waiting for PUSH_GLOBAL after 1 minute - something is broke');
            } else {
                setTimeout(this.pushGlobalReady, 100);	// check every 100ms
            }
        }
    }

    // add listeners
    addListeners() {
        var _this = this

        window.addEventListener('umga:social-popup-init', (evt) => _this.socialPopup(evt))
        window.addEventListener('umga:social-link-clicked', (evt) => _this.socialLinkClicked(evt))
        window.addEventListener('umga:newsletter-signup', (evt) => _this.newsletterSignUp(evt))
        window.addEventListener('umga:search-results', (evt) => _this.searchResults(evt))
        window.addEventListener('umga:no-search-results', (evt) => _this.noSearchResults(evt))
        window.addEventListener('umga:login', (evt) => _this.login(evt))
        window.addEventListener('umga:register', (evt) => _this.register(evt))
        window.addEventListener('umga:pdp-image-click', (evt) => _this.pdpImageClick(evt))
        window.addEventListener('umga:remove-from-cart', (evt) => _this.removeFromCart(evt))
        window.addEventListener('umga:product-click', (evt) => _this.productClick(evt))
        window.addEventListener('umga:select-item', (evt) => _this.selectItem(evt))
        window.addEventListener('umga:product-impression', (evt) => _this.productImpression(evt))
        window.addEventListener('umga:view-item-list', (evt) => _this.viewItemList(evt))
        window.addEventListener('umga:view-item', (evt) => _this.viewItem(evt))
        window.addEventListener('umga:view-cart', (evt) => _this.viewCart(evt))
        window.addEventListener('umga:remove-from-cart-v2', (evt) => _this.removeFromCartV2(evt))
        window.addEventListener('umga:add-to-cart-v2', (evt) => _this.addToCartV2(evt))
        window.addEventListener('umga:product-detail', (evt) => _this.productDetail(evt))
        window.addEventListener('umga:add-to-cart', (evt) => _this.addToCart(evt))
        window.addEventListener('umga:checkout', (evt) => _this.checkout(evt))
        window.addEventListener('umga:purchase', (evt) => _this.purchase(evt))
        window.addEventListener('umga:page-data-loaded', (evt) => _this.pageDataLoaded(evt))
    }

    pushStoredEvents() {
        for (let evt in this.userEvents) {
            window.dataLayer.push({
                ...evt
            })
        }
    }

    socialLinkClicked(e) {
        const {
            platform,
            location,
            url,
        } = e.detail
        this.pushEvent('socialLink', {
            platform,
            location,
            linkURL: url
        })
    }

    socialPopup(e) {
        const {
            name,
            text,
        } = e.detail
        this.pushEvent('socialPopup', {
            popupName: name,
            popupText: text,
        })
    }

    newsletterSignUp(e) {
        const {
            formName,
            platform,
            userData,
        } = e.detail
        this.pushEvent('newsletterSignup', {
            formName,
            platform,
            userData,
        })
    }

    searchResults(e) {
        const {
            searchTerm,
        } = e.detail
        this.pushEvent('searchResults', {
            searchTerm,
        })
    }

    noSearchResults(e) {
        const {
            searchTerm,
        } = e.detail
        this.pushEvent('noSearchResults', {
            searchTerm,
        })
    }

    pdpImageClick(e) {
        const {
            imageName,
            imageURL,
            products,
        } = e.detail
        this.pushEvent('pdpImageClick', {
            imageName,
            imageURL,
            products,
        })
    }

    removeFromCart(e) {
        const {
            ecommerce,
        } = e.detail
        this.pushEvent('removeFromCart', {
            ecommerce,
        })
    }

    productClick(e) {
        const {
            ecommerce,
        } = e.detail
        this.pushEvent('productClick', {
            ecommerce,
        })
    }

    selectItem(e) {
        try {
            if (
                e.detail
                && e.detail.currency
                && e.detail.items
                && Array.isArray(e.detail.items)
            ) {
                const { currency, items } = e.detail;
                this.pushEvent(
                    'select_item',
                    {
                        'currency': currency,
                        items
                    }
                )   
            }
        } catch (error) {
            console.error(error)
        }
    }

    productImpression(e) {
        const {
            ecommerce,
        } = e.detail
        this.pushEvent('productImpression', {
            ecommerce,
        })
    }

    viewCart(e) {
        if (
            e.detail
            && e.detail.currency
            && e.detail.items
            && 'value' in e.detail
            && Array.isArray(e.detail.items)
        ) {
            const { currency, items, value } = e.detail;
            this.pushEvent(
                'view_cart',
                {
                    'currency': currency,
                    items,
                    value
                }
            )
        } else {
            //Log error
        }
    }

    addToCartV2(e) {
        if (
            e.detail
            && e.detail.currency
            && e.detail.items
            && 'value' in e.detail
            && Array.isArray(e.detail.items)
        ) {
            const { currency, items, value } = e.detail;
            this.pushEvent(
                'add_to_cart',
                {
                    'currency': currency,
                    items,
                    value
                }
            )
        } else {
            //Log error
        }        
    }

    removeFromCartV2(e) {
        if (
            e.detail
            && e.detail.currency
            && e.detail.items
            && 'value' in e.detail
            && Array.isArray(e.detail.items)
        ) {
            const { currency, items, value } = e.detail;
            this.pushEvent(
                'remove_from_cart',
                {
                    'currency': currency,
                    items,
                    value
                }
            )
        } else {
            //Log error
        }
    }
    viewItem(e) {
        if (
            e.detail
            && e.detail.currency
            && e.detail.items
            && Array.isArray(e.detail.items)
        ) {
            const { currency, items } = e.detail;
            this.pushEvent(
                'view_item',
                {
                    'currency': currency,
                    items
                }
            )
        } else {
            //Log error
        }
    }

    viewItemList(e) {
        if (
            e.detail 
            && e.detail.currency
            && e.detail.items
            && Array.isArray(e.detail.items)
        ) {
            const { currency, items } = e.detail;
            this.pushEvent(
                'view_item_list', 
                {
                    'currency': currency,
                    items
                }
            )
        } else {
            //Log error
        }
    }

    productDetail(e) {
        const {
            stockStatus,
            ecommerce,
        } = e.detail
        this.pushEvent('productDetail', {
            stockStatus,
            ecommerce,
        })
    }

    addToCart(e) {
        const {
            ecommerce,
        } = e.detail
        this.pushEvent('addToCart', {
            ecommerce,
        })
    }

    checkout(e) {
        const {
            ecommerce,
        } = e.detail
        this.pushEvent('checkout', {
            ecommerce,
        })
    }

    purchase(e) {
        const {
            ecommerce,
        } = e.detail
        this.pushEvent('purchase', {
            ecommerce,
        })
    }

    login(e) {
        const {
            userId,
            platform,
        } = e.detail
        this.pushEvent('login', {
            userId,
            platform,
        })
    }

    register(e) {
        const {
            userId,
            platform,
        } = e.detail
        this.pushEvent('register', {
            userId,
            platform,
        })
    }

    pageDataLoaded(e) {
        const {
            countryCode,
            storePlatform,
            storeType,
            userId,
        } = e.detail
        this.pushEvent('pageview', {
            countryCode,
            storePlatform,
            storeType,
            userId,
        })
    }

    getEvidonAnalyticsConsent() {
        let consentDetails = null
        if (typeof window.evidon !== 'undefined' && 'settings' in evidon) {
            const evidonKey = Object.keys(evidon.settings)
                .find((key) => {
                    const pattern = '^'
                        + window.location.host.replace('www.', '')
                        + '\|\d{5}$'
                    const rgx = new RegExp(pattern, 'g')
                    return key.match(rgx)
                })
            if (evidonKey in evidon.settings) {
                consentDetails = JSON.parse(
                    localStorage.getItem(
                        '_evidon_consent_ls_' + evidon.settings[evidonKey].id
                    )
                )
            }
        } else if (
            typeof window.evidon !== 'undefined'
            && 'notice' in evidon
            && 'settings' in evidon.notice
        ) {
            const evidonKey = Object.keys(evidon.notice.settings)
                .find((key) => {
                    const pattern = '^'
                        + window.location.host.replace('www.', '')
                        + '\|\d{5}$'
                    const rgx = new RegExp(pattern, 'g')
                    return key.match(rgx)
                })
            if (evidonKey in evidon.notice.settings) {
                consentDetails = JSON.parse(
                    localStorage.getItem(
                        '_evidon_consent_ls_' + evidon.notice.settings[evidonKey].id
                    )
                )
            }
        }
        if (
            consentDetails
            && 'categories' in consentDetails
            && '6' in consentDetails.categories
            && 'performance and analytics' in consentDetails.categories[6]
        ) {
            return consentDetails.categories[6]['performance and analytics']
        }
        return false
    }

    pushEvent(name, data) {
        const analyticsConsent = true
        if (analyticsConsent) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                'event': name,
                ...data
            })
        } else {
            this.userEvents = this.userEvents || []
            this.userEvents.push({
                'event': name,
                ...data
            })
        }
    }

    onLogin(user, type, sso) {
        const lastService = AEJSWP.getLastLoginService(user.services)
        if (type === 'login') {
            let evt = new CustomEvent('umga:login', {
                detail: {
                    userId: user.data.ID,
                    platform: lastService.Service,
                }
            })
            window.dispatchEvent(evt)
        } else if (type === 'registration') {
            let evt = new CustomEvent('umga:register', {
                detail: {
                    userId: user.data.ID,
                    platform: lastService.Service,
                }
            })
            window.dispatchEvent(evt)
        }
    }

    firePageDataLoaded() {
        const countryCode = typeof PUSH_GLOBAL !== 'undefined' && 'geo_ip_country' in PUSH_GLOBAL
            ? PUSH_GLOBAL.geo_ip_country : null

        let storePlatform = localStorage.getItem('umggr-ecommerce-type')
        if (!storePlatform && typeof UMGGR !== 'undefined' && 'defaultSoreType' in UMGGR) {
            storePlatform = UMGGR.defaultSoreType
        }
        if (!storePlatform && typeof UMGCOPE !== 'undefined') {
            storePlatform = 'cope'
        }
        storePlatform = storePlatform && this.storeTypesMap[storePlatform]

        const storeType = storePlatform ? 'Embedded Store' : null

        const userId = typeof AEJSWP !== 'undefined' && typeof AEJSWP.aeJS !== 'undefined'
        && typeof AEJSWP.aeJS.user !== 'undefined'
        && typeof AEJSWP.aeJS.user.data.ID !== 'undefined'
            ? AEJSWP.aeJS.user.data.ID
            : typeof aeJS !== 'undefined' && typeof aeJS !== 'undefined'
            && typeof aeJS.user !== 'undefined'
            && typeof aeJS.user.data.ID !== 'undefined'
                ? aeJS.user.data.ID
                : null

        const evt = new CustomEvent('umga:page-data-loaded', {
            detail: {
                countryCode,
                storePlatform,
                storeType,
                userId,
            }
        })
        window.dispatchEvent(evt)
    }

    addOnWindowLoadEventListeners() {
        const socialLinks = document.querySelectorAll('[data-umga-social-link]')

        socialLinks.forEach((item) => {
            item.addEventListener('click', () => {
                const platform = item.getAttribute('data-umga-social-link-platform')
                const location = item.getAttribute('data-umga-social-link-location')
                const url = item.getAttribute('href')
                const evt = new CustomEvent('umga:social-link-clicked', {
                    detail: {
                        platform,
                        location,
                        url,
                    }
                })
                window.dispatchEvent(evt)
            })

        })

        if (!this.pageViewEventFired) {
            this.pushGlobalReady()
        }
    }

    socialPopUpClicked(customFormId) {
        localStorage.setItem('umga-social-popup-custom-from-id', customFormId)
    }

    onWindow(state) {
        if (state.type === 'popup' && state.state === 'opened') {
            const customFormId = localStorage.getItem('umga-social-popup-custom-from-id')
            const text = AEJSWP.custom_forms[customFormId].flow_labels["signin_title"]
            const name = state.service
            const evt = new CustomEvent('umga:social-popup-init', {
                detail: {
                    name,
                    text,
                }
            })
            window.dispatchEvent(evt)
        }
    }
}

window.UMGAnalytics = new UMGAnalytics()

window.onload = () => {

    let waitForAejsRetryCount = 0
    let socialPopUpEventsAdded = false

    customAEJSReady = function () {
        if (typeof AEJSWP !== 'undefined') {
            AEJSWP.mailingListFormCompleteCallback = (customFormId, user_data) => {
                let user_data_lowercase = Object.keys(user_data).reduce((accumulator, currentKey) => {
                    accumulator[currentKey.toLowerCase()] = user_data[currentKey];
                    return accumulator;
                  }, {}); 
                const lastService = 'aeJS' in AEJSWP
                && 'user' in AEJSWP.aeJS
                && 'services' in AEJSWP.aeJS.user
                && AEJSWP.aeJS.user.services
                    ? AEJSWP.getLastLoginService(AEJSWP.aeJS.user.services).Service
                    : 'email'
                const evt = new CustomEvent('umga:newsletter-signup', {
                    detail: {
                        formName: AEJSWP.custom_forms[customFormId].flow_labels["signin_title"],
                        platform: lastService,
                        userData: user_data_lowercase
                    }
                })
                
                window.dispatchEvent(evt)
            }
        }
        if (typeof AEJSWP !== 'undefined' && typeof AEJSWP.aeJS !== 'undefined') {
            AEJSWP.aeJS.events.onLogin.addHandler(window.UMGAnalytics.onLogin)
            AEJSWP.aeJS.events.onWindow.addHandler(window.UMGAnalytics.onWindow)
            if (!socialPopUpEventsAdded) {
                socialPopUpEventsAdded = true
                const modals = document.querySelectorAll('.ae-cform-container')
                modals.forEach((modal) => {
                    const customFormId = modal.getAttribute('data-ae-cform-id')
                    let socialButtons = []
                    if (modal.classList.contains('-has-modal')) {
                        socialButtons = document.querySelectorAll(`#ae-cform-modal-container-${customFormId} .ae-cform-social-link`)
                    } else {
                        socialButtons = document.querySelectorAll(`#ae-cform-container-${customFormId} .ae-cform-social-link`)
                    }
                    socialButtons.forEach((btn) => btn.addEventListener(
                        'click',
                        () => {
                            window.UMGAnalytics.socialPopUpClicked(customFormId)
                    }))
                })
            }
        } else if (typeof aeJS !== 'undefined') {
            aeJS.events.onLogin.addHandler(window.UMGAnalytics.onLogin)
            aeJS.events.onWindow.addHandler(window.UMGAnalytics.onWindow)
        } else {
            waitForAejsRetryCount++;
            // wait a maximum of 1 minute
            if (waitForAejsRetryCount > 600) {
                console.log('UMG Analytics: Giving up waiting for aeJS after 1 minute - something is broke');
            } else {
                setTimeout(window.customAEJSReady, 100);	// check every 100ms
            }
        }
    }
    customAEJSReady()
}
